
import "./PaymentMethodList.css";

import {
  CreditCard,
  Truck,
  CalendarClock,
  CheckCircle2,
} from "lucide-react";

import GatewayList from "../GatewayList/GatewayList";

import { usePayment } from "../../../../../context/PaymentContext";

export default function PaymentMethodList() {

  const {
    paymentMethod,
    setPaymentMethod,

    gateways,
    selectedGateway,
    selectGateway,
    gatewayLoading,
  } = usePayment();


  const handleMethodSelect = (method) => {

    setPaymentMethod(method);

  };


  return (
    <section
      className="payment-method-list"
      dir="rtl"
    >

      {/* ==================================================
                TITLE
            ================================================== */}

      <div className="section-title">
        روش پرداخت
      </div>


      <div className="payment-method-options">


        {/* ==================================================
                    ONLINE
                ================================================== */}

        <div
          className={`payment-method-group ${paymentMethod === "online"
              ? "active"
              : ""
            }`}
        >

          <button
            type="button"
            className="payment-method-option"
            onClick={() =>
              handleMethodSelect("online")
            }
          >

            <span className="payment-method-radio">

              {paymentMethod === "online" && (
                <CheckCircle2 size={17} />
              )}

            </span>


            <span className="payment-method-option-icon">

              <CreditCard size={21} />

            </span>


            <span className="payment-method-option-content">

              <strong>
                پرداخت آنلاین
              </strong>

              <small>
                پرداخت از طریق درگاه بانکی
              </small>

            </span>

          </button>


          {paymentMethod === "online" && (

            <div className="payment-method-details">

              <GatewayList
                gateways={gateways}
                selectedGateway={
                  selectedGateway
                }
                onSelect={
                  selectGateway
                }
                loading={
                  gatewayLoading
                }
              />

            </div>

          )}

        </div>


        {/* ==================================================
                    CASH ON DELIVERY
                ================================================== */}

        {/* <div
          className={`payment-method-group ${paymentMethod === "cash"
              ? "active"
              : ""
            }`}
        >

          <button
            type="button"
            className="payment-method-option"
            onClick={() =>
              handleMethodSelect("cash")
            }
          >

            <span className="payment-method-radio">

              {paymentMethod === "cash" && (
                <CheckCircle2 size={17} />
              )}

            </span>


            <span className="payment-method-option-icon">

              <Truck size={21} />

            </span>


            <span className="payment-method-option-content">

              <strong>
                پرداخت در محل
              </strong>

              <small>
                پرداخت هنگام دریافت سفارش
              </small>

            </span>

          </button>


          {paymentMethod === "cash" && (

            <div className="payment-method-sub-details">

              <div className="payment-info">

                <span>
                  پرداخت در محل
                </span>

                <small>
                  این روش در صورت واجد شرایط بودن
                  آدرس و سفارش قابل استفاده است.
                </small>

              </div>

            </div>

          )}

        </div> */}


        {/* ==================================================
                    INSTALLMENT
                ================================================== */}

        {/* <div
          className={`payment-method-group ${paymentMethod === "installment"
              ? "active"
              : ""
            }`}
        >

          <button
            type="button"
            className="payment-method-option"
            onClick={() =>
              handleMethodSelect(
                "installment"
              )
            }
          >

            <span className="payment-method-radio">

              {paymentMethod === "installment" && (
                <CheckCircle2 size={17} />
              )}

            </span>


            <span className="payment-method-option-icon">

              <CalendarClock size={21} />

            </span>


            <span className="payment-method-option-content">

              <strong>
                پرداخت اقساطی
              </strong>

              <small>
                خرید قسطی و اعتباری
              </small>

            </span>

          </button>


          {paymentMethod === "installment" && (

            <div className="payment-method-sub-details">

              <button
                type="button"
                className="installment-provider selected"
              >

                <span className="provider-radio">

                  <CheckCircle2
                    size={16}
                  />

                </span>


                <span className="provider-content">

                  <strong>
                    پرداخت قسطی و اعتباری با اسنپ‌پی
                  </strong>

                  <small>
                    پرداخت در چهار قسط
                  </small>

                </span>

              </button>

            </div>

          )}

        </div> */}




      </div>

    </section>
  );
}
